const MIMEType = {
    UNSPECIFIED: ["application/octet-stream"],

    JPEG: ["image/jpeg"],
    PNG: ["image/png"],
    GIF: ["image/gif"],
    WEBP: ["image/webp"],

    MP4: ["video/mp4"],
    AVI: ["video/avi"],
    MPEG: ["video/mpeg"],
    WEBM: ["video/webm"],

    MP3: ["audio/mpeg"],
    WAV: [
        "audio/wav",
        "audio/wave",
        "audio/x-wav",
        "audio/vnd.wave",
        "audio/x-pn-wav",
        "application/wav",
        "application/x-wav",
    ],
    OGG: ["audio/ogg"],
};
export const CategoryType = {
    IMAGE: "image",
    VIDEO: "video",
    AUDIO: "audio",
};

function MIMETypeInfo(type, extensions) {
    this.type = type;
    this.extensions = extensions;
}

export const MediaMimeTypes = {
    images: [
        new MIMETypeInfo(MIMEType.JPEG, [".jpg", ".jpeg", ".jpe"]),
        new MIMETypeInfo(MIMEType.PNG, [".png"]),
        new MIMETypeInfo(MIMEType.GIF, [".gif"]),
        new MIMETypeInfo(MIMEType.WEBP, [".webp"]),
    ],
    audios: [
        new MIMETypeInfo(MIMEType.MP3, [".mp3", ".mpeg", ".mpga"]),
        new MIMETypeInfo(MIMEType.WAV, [".wav"]),
        new MIMETypeInfo(MIMEType.OGG, [".ogg", ".oga"]),
    ],
    videos: [
        new MIMETypeInfo(MIMEType.MP4, [".mp3", ".mpeg", ".mpga"]),
        new MIMETypeInfo(MIMEType.AVI, [".avi"]),
        new MIMETypeInfo(MIMEType.MPEG, [".mpeg", ".mpg", ".mpe"]),
        new MIMETypeInfo(MIMEType.WEBM, [".webm"]),
    ],

    getMediaTypeCategoryFromFile(file) {
        const contentType = file.type || MIMEType.UNSPECIFIED;

        for (let image of this.images) {
            if (image.type.includes(contentType)) {
                return CategoryType.IMAGE;
            }
        }
        for (let audio of this.audios) {
            if (audio.type.includes(contentType)) {
                return CategoryType.AUDIO;
            }
        }
        for (let video of this.videos) {
            if (video.type.includes(contentType)) {
                return CategoryType.VIDEO;
            }
        }

        return null;
    }
};

